module.exports = __webpack_public_path__ + "static/img/contact_icon.039ed3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/contact_icon.png
// module id = IKU1
// module chunks = 0